package one.healthium.reminders.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class ReminderDto(
    @SerialName("notifications") val notifications: List<ReminderNotificationDto>,
    @SerialName("deepLink") val deepLink: String?,
    @SerialName("type") val type: ReminderTypeDto,
)

@Serializable
internal sealed interface ReminderTypeDto {
    val time: String
    val timeWindowMinutes: Int?

    @Serializable
    @SerialName("periodic")
    data class Periodic(
        @SerialName("time") override val time: String,
        @SerialName("period") val period: String,
        @SerialName("timeWindowMinutes") override val timeWindowMinutes: Int?,
    ) : ReminderTypeDto

    @Serializable
    @SerialName("one_time")
    data class OneTime(
        @SerialName("time") override val time: String,
        @SerialName("timeWindowMinutes") override val timeWindowMinutes: Int?,
    ) : ReminderTypeDto
}

@Serializable
internal data class ReminderNotificationDto(
    @SerialName("title") val title: String,
    @SerialName("text") val description: String,
)